import { render, staticRenderFns } from "./AssetV3.vue?vue&type=template&id=8c677736&scoped=true"
import script from "./AssetV3.vue?vue&type=script&lang=js"
export * from "./AssetV3.vue?vue&type=script&lang=js"
import style0 from "./AssetV3.vue?vue&type=style&index=0&id=8c677736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c677736",
  null
  
)

export default component.exports